import * as React from 'react';
import {
    List,
    Datagrid,
    DateField,
    TextField,
    SearchInput,
    TextInput,
} from 'react-admin';
import { useMediaQuery, Theme } from '@mui/material';

import MobileGrid from './MobileGrid';

const entityFilters = [
    <SearchInput source="q" alwaysOn />,
    <TextInput source="id" />,
    <TextInput source="full_name" />,
];

const EntityList = () => {
    const isXsmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    // const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    return (
        // @ts-ignore
        <List
            filters={entityFilters}
            resource="logix_client_metas"
            sort={{ field: 'id', order: 'ASC' }}
            perPage={25}
        >
            {isXsmall ? (
                <MobileGrid />
            ) : (
                <Datagrid
                    optimized
                    rowClick="edit"
                    sx={{
                        '& .column-groups': {
                            md: { display: 'none' },
                            lg: { display: 'table-cell' },
                        },
                    }}
                >
                    <TextField source="id" />
                    <TextField source="full_name" />
                    <TextField source="leader_name" />
                    <TextField source="leader_position" />
                    <DateField source="created" showTime={true} />
                    <DateField source="modified" showTime={true} />
                </Datagrid>
            )}
        </List>
    );
};

export default EntityList;
